import React from 'react'

function Button(props) {
    const { text, className, onclickfun, disabled = false, style } = props

    return (
        <button 
            className={className} 
            onClick={(e) => onclickfun(e)}
            disabled={disabled}
            style={style}
        >
            { disabled ?  'Loading.....' : text}
        </button>
    )
}

export default Button;